







































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

const on = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event && handler) {
			element.addEventListener(event, handler, false);
		}
	};
})();

const off = (function() {
	return function(element: any, event: any, handler: any) {
		if (element && event) {
			element.removeEventListener(event, handler, false);
		}
	};
})();

@Component
export default class ElSplit extends Vue {
	@Prop({ type: Number, default: 100 }) height!: number;
	@Prop({ type: [Number, String], default: 0.5 }) value!: number | string;
	@Prop({
		type: String,
		default: "horizontal",
		validator(value) {
			return !!["horizontal", "vertical"].find(item => item === value);
		}
	})
	mode!: string;
	@Prop({ type: [Number, String], default: "40px" }) min!: number | string;
	@Prop({ type: [Number, String], default: "40px" }) max!: number | string;

	offset: number = 0;
	oldOffset: number = 0;
	isMoving: boolean = false;

	get wrapperClasses() {
		return [`split-wrapper`, this.isMoving ? "no-select" : ""];
	}
	get paneClasses() {
		return [
			`split-pane`,
			{
				[`split-pane-moving`]: this.isMoving
			}
		];
	}
	get isHorizontal() {
		return this.mode === "horizontal";
	}
	get anotherOffset() {
		return 100 - this.offset;
	}
	get valueIsPx() {
		return typeof this.value === "string";
	}
	get offsetSize() {
		return this.isHorizontal ? "offsetWidth" : "offsetHeight";
	}
	get computedMin() {
		return this.getComputedThresholdValue("min");
	}
	get computedMax() {
		return this.getComputedThresholdValue("max");
	}

	@Watch("value")
	onValueWatch() {
		this.computeOffset();
	}

	mounted() {
		this.$nextTick(() => {
			this.computeOffset();
		});
		window.addEventListener("resize", () => {
			this.computeOffset();
		});
	}

	px2percent(numerator: string, denominator: string) {
		return parseFloat(numerator) / parseFloat(denominator);
	}
	getComputedThresholdValue(type: any) {
		let size = (this.$refs.outerWrapper as any)[this.offsetSize];
		if (this.valueIsPx)
			return typeof (this as any)[type] === "string"
				? (this as any)[type]
				: size * (this as any)[type];
		else
			return typeof (this as any)[type] === "string"
				? this.px2percent((this as any)[type], size)
				: (this as any)[type];
	}
	getMin(value1: number, value2: number) {
		if (this.valueIsPx)
			return `${Math.min(
				parseFloat(String(value1)),
				parseFloat(String(value2))
			)}px`;
		else return Math.min(value1, value2);
	}
	getMax(value1: number, value2: number) {
		if (this.valueIsPx)
			return `${Math.max(
				parseFloat(String(value1)),
				parseFloat(String(value2))
			)}px`;
		else return Math.max(value1, value2);
	}
	getAnotherOffset(value: number) {
		let res: string | number = 0;
		if (this.valueIsPx)
			res = `${(this.$refs.outerWrapper as any)[this.offsetSize] -
				parseFloat(String(value))}px`;
		else res = 1 - value;
		return res;
	}
	handleMove(e: MouseEvent) {
		let pageOffset = this.isHorizontal ? e.pageX : e.pageY;
		let offset = pageOffset - (this as any).initOffset;
		let outerWidth = (this.$refs.outerWrapper as any)[this.offsetSize];
		let value = this.valueIsPx
			? `${parseFloat(String(this.oldOffset)) + offset}px`
			: this.px2percent(
					String(outerWidth * this.oldOffset + offset),
					outerWidth
			  );
		let anotherValue = this.getAnotherOffset(Number(value));
		if (parseFloat(String(value)) <= parseFloat(this.computedMin))
			value = this.getMax(Number(value), this.computedMin);
		if (parseFloat(String(anotherValue)) <= parseFloat(this.computedMax))
			value = this.getAnotherOffset(
				(this as any).getMax(anotherValue, this.computedMax)
			);
		(e as any).atMin = this.value === this.computedMin;
		(e as any).atMax = this.valueIsPx
			? this.getAnotherOffset(Number(this.value)) === this.computedMax
			: Number(this.getAnotherOffset(Number(this.value))).toFixed(5) ===
			  this.computedMax.toFixed(5);
		this.$emit("input", value);
		this.$emit("on-moving", e);
	}
	handleUp() {
		this.isMoving = false;
		off(document, "mousemove", this.handleMove);
		off(document, "mouseup", this.handleUp);
		this.$emit("on-move-end");
	}
	handleMousedown(e: MouseEvent) {
		(this as any).initOffset = this.isHorizontal ? e.pageX : e.pageY;
		(this as any).oldOffset = this.value;
		this.isMoving = true;
		on(document, "mousemove", this.handleMove);
		on(document, "mouseup", this.handleUp);
		this.$emit("on-move-start");
	}
	computeOffset() {
		this.offset =
			(((this as any).valueIsPx
				? this.px2percent(
						(this as any).value,
						(this.$refs.outerWrapper as any)[this.offsetSize]
				  )
				: (this as any).value) *
				10000) /
			100;
	}
}
